"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const airbridge_web_sdk_loader_1 = __importDefault(require("airbridge-web-sdk-loader"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const modals_1 = require("@/modals");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const list_subcriptions_1 = __importDefault(require("./list-subcriptions"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const WAIT_BEFORE_REFRESH_USER = 2000;
const SubscriptionsScreen = ({ subscriptionOptions, habitJourneys, user, cancelSubscription, location, refreshUser, currentSubscription }) => {
    var _a, _b;
    const [subscription, setSubscription] = (0, react_1.useState)(((_a = subscriptionOptions[0]) === null || _a === void 0 ? void 0 : _a.value) || "");
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [showCancelSuccess, setShowCancelSuccess] = (0, react_1.useState)(false);
    const [subscriptionData, setSubscriptionData] = (0, react_1.useState)(null);
    const refreshUserData = () => {
        setTimeout(() => {
            refreshUser();
        }, WAIT_BEFORE_REFRESH_USER);
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (user && !user.subscribed) {
            airbridge_web_sdk_loader_1.default.events.send('airbridge.ecommerce.productList.viewed');
        }
        if (user && ((_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.success) && !user.subscribed) {
            refreshUserData();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (!subscription && subscriptionOptions.length > 0) {
            const firstAnnual = subscriptionOptions.find(item => item.label.toLowerCase().includes('annual')) || subscriptionOptions[0];
            setSubscription(firstAnnual.value);
        }
    }, [subscriptionOptions]);
    if (!user) {
        return null;
    }
    const handleCancelSubscription = () => {
        if (user.subscribed && user.subscriptionID) {
            components_1.modalEvents.setAndRender(modals_1.ModalNames.USER_CANCEL_SUBSCRIPTION, react_1.default.createElement(modals_1.UserCancelSubscriptionModal, { onCancel: () => {
                    cancelSubscription({ subscription_id: user.subscriptionID });
                    setShowCancelSuccess(true);
                    refreshUserData();
                } }));
        }
        else if (user.subscribed && !user.subscriptionID) {
            components_1.modalEvents.setAndRender(modals_1.ModalNames.ORIGINAL_CANCEL_SUBSCRIPTION, react_1.default.createElement(modals_1.UserOriginalSubscriptionModal, null));
        }
    };
    const createSubscription = () => __awaiter(void 0, void 0, void 0, function* () {
        if (subscription) {
            setSubscriptionData({ productID: subscription });
        }
    });
    if (subscriptionData) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: {
                pathname: constants_1.Routes.Subscribe,
                state: subscriptionData
            } });
    }
    if ((_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.success) {
        components_1.modalEvents.setAndRender(modals_1.ModalNames.SUBSCRIPTION_SUCCESS, react_1.default.createElement(modals_1.SubscriptionSuccessModal, null));
    }
    return (react_1.default.createElement("div", { className: styles_scss_1.default.container },
        showCancelSuccess && (react_1.default.createElement(components_1.Banner, { title: constants_1.default.subscriptions.cancelSuccessMessage, description: constants_1.default.subscriptions.youWillRetain, backgroundColor: styles_scss_1.default.bannerSuccess, width: "100%" })),
        (user === null || user === void 0 ? void 0 : user.subscribed) ? (react_1.default.createElement("div", { className: styles_scss_1.default.subscribedContainer },
            react_1.default.createElement("h2", { className: styles_scss_1.default.subTitle }, constants_1.default.subscriptions.subscriptionPlan),
            !!currentSubscription && react_1.default.createElement("h3", { className: styles_scss_1.default.plan }, currentSubscription.product_data.name),
            react_1.default.createElement(components_1.Button, { type: "button", title: constants_1.default.subscriptions.cancelSubscription, className: styles_scss_1.default.cancelButton, onClick: handleCancelSubscription }))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(list_subcriptions_1.default, { habitJourneys: habitJourneys, subscriptionOptions: subscriptionOptions, subscription: subscription, handleContinuePress: () => {
                    airbridge_web_sdk_loader_1.default.events.send('airbridge.initiateCheckout');
                    setLoading(true);
                    createSubscription();
                }, handleRadioChange: (val) => setSubscription(val), loading: loading })))));
};
const mapStateToProps = (state) => ({
    habitJourneys: selectors_1.default.habit.getHabitJourneys(state),
    user: selectors_1.default.user.getUser(state),
    subscriptionOptions: selectors_1.default.payment.getSubscriptions(state),
    currentSubscription: selectors_1.default.payment.getSubscriptionFromUser(state)
});
const mapDispatchToProps = (dispatch) => ({
    cancelSubscription: (data) => dispatch(radio_dispatch_1.reduxSet.makeRequest.dispatch((0, api_payloads_1.cancelSubscriptionsPayload)(data))),
    refreshUser: () => dispatch(radio_dispatch_1.reduxSet.makeRequest.dispatch((0, api_payloads_1.hydrateUserPayload)()))
});
SubscriptionsScreen.defaultProps = {
    location: null
};
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(SubscriptionsScreen);
